export default __webpack_public_path__ + "static/media/spinachsupercocktail@3x.6c2947bf.jpg";